package com.iptvplayer.shared.db

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.iptvplayer.shared.db.shared.newInstance
import com.iptvplayer.shared.db.shared.schema
import kotlin.Unit

public interface IPTVDatabase : Transacter {
  public val cacheMetaQueries: CacheMetaQueries

  public val channelQueries: ChannelQueries

  public val favoriteQueries: FavoriteQueries

  public val iptvSourceQueries: IptvSourceQueries

  public val seriesQueries: SeriesQueries

  public val vodItemQueries: VodItemQueries

  public val watchHistoryQueries: WatchHistoryQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = IPTVDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): IPTVDatabase =
        IPTVDatabase::class.newInstance(driver)
  }
}
